import React from 'react';
import { TableFooter, TableRow, TableCell } from '@material-ui/core'

export const BigCalendarFooterBase = ({ totalSourceMonth, classes, totalPercent }) => (
  <TableFooter>
    <TableRow className={classes.row}>
      <TableCell
        colSpan={2}
        rowSpan={2}
        padding='dense'
      >
        Підсумок:
      </TableCell>
      {totalSourceMonth.map(({ limit, booked }, index) => (
        <TableCell
          numeric
          key={index}
          className={classes.totalCell}
          padding={index + 1 === totalSourceMonth.length ? 'dense' : 'none'}
        >
          {booked}/{limit}
        </TableCell>
      ))}
    </TableRow>

    <TableRow className={classes.row}>
      {totalPercent.map((procent, index) => (
        <TableCell
          numeric
          key={index}
          padding={index + 1 === totalPercent.length ? 'dense' : 'none'}
          className={classes.percentCell}
        >
          {procent}%
        </TableCell>
      ))}
    </TableRow>
  </TableFooter>
)



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarFooter/BigCalendarFooter.js